var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.163 3.945a.892.892 0 0 0 .263-.635.892.892 0 0 0-.263-.635l-.712-.712a.892.892 0 0 0-.635-.263.892.892 0 0 0-.634.263L2.408 6.722v1.982H4.39l4.773-4.759zM7.816 2.598l.713.712-.714.711-.712-.712.713-.71zm-4.51 5.208v-.712l3.161-3.15.712.711-3.16 3.151h-.713zm-.898 1.796h7.184v.898H2.408v-.898z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7cac90ba480e1a213e7885fc72950f66.svg";
export { ForwardRef as ReactComponent };